let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gzVLb")).then(() => parcelRequire('8LbUN'));